<template>
  <div :class="`form-group ${error ? 'has-error' : ''}`">
    <label class="control-label" v-show="label">
      {{ label }}
      <span v-if="requiredMark" class="text-danger">*</span>
    </label>
    <select
      class="form-control"
      v-bind="$attrs"
      @blur="$emit('blur', $event)"
      @change="$emit('input', $event.target.value)"
    >
      <option v-if="emptyOption" value="">{{ emptyOptionLabel }}</option>

      <option
        v-if="!isGroupOption"
        v-for="option in options"
        :value="option[valueKey || 'value']"
        :selected="String(option[valueKey || 'value']) === String(value)"
      >{{ option[labelKey || 'text'] }}</option>

      <optgroup
        v-if="isGroupOption"
        v-for="group in options"
        :label="group.label"
      >
        <option
          v-for="option in group.options"
          :value="option[valueKey || 'value']"
          :selected="String(option[valueKey || 'value']) === String(value)"
        >{{ option[labelKey || 'text'] }}</option>
      </optgroup>
    </select>
    <small class="text-danger" v-if="error">{{ error }}</small>
    <span class="help-block" v-if="help">{{ help }}</span>
  </div>
</template>

<script>
export default {
  props: [
    'value',
    'error',
    'label',
    'options',
    'help',
    'emptyOption',
    'valueKey',
    'labelKey',
    'emptyOptionLabel',
    'requiredMark',
    'isGroupOption'
  ]
}
</script>
